






































































































































































































































import _ from 'lodash';
import numeral from 'numeral';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import {Http} from '@/decorators';
import {httpService} from '@/services';
import ReportLegend from '@/modules/neodash/components/report-legend/report-legend.vue';
import {CONFIG} from '@/config';
import {REPORT_GET_REPORTS} from '@/modules/neodash/store/modules/report/types';
import {PRINT_GET_PRINT_MODE} from '@/store/modules/print/types';
import * as moment from 'moment';

import KendoChart from '@/components/kendo-chart/kendo-chart.vue';
import {Size} from '@/enums';
import {ApprovalHierarchyType, SalesChannel} from '@/modules/direct-sales/enums';
import NoDataAvailable from '@/modules/neodash/components/no-data-available/no-data-available.vue';
import {AxiosResponse, AxiosError} from 'axios';

declare const $: any;

@Component({
  components: {
    ReportLegend,
    KendoChart,
    NoDataAvailable
  }
})
export default class RetailPerformanceByFamily extends Vue {
  @Prop({required: true})
  dataQuery: any;

  public moment = moment;
  public numeral = numeral;

  @Getter(REPORT_GET_REPORTS)
  reports: any;
  @Getter(PRINT_GET_PRINT_MODE)
  printMode: any;

  public state: any = {
    currentMonth: new Date().getMonth(),
    currentYear: new Date().getFullYear(),
    data: {},
    entries: [],
    channels: [],
    project: {}
  };

  public Size = Size;

  public get years() {
    return _.uniq(this.periods.map((p: any) => p.year));
  }

  public get periods() {
    if (!_.size(this.state.data)) {
      return [];
    }
    return _([
      ...this.state.data.forecast_RapFamilyResultsPerMonth.map((d: any) => {
        d.editable = !(d.year <= this.state.currentYear && d.month <= this.state.currentMonth);
        return d;
      })
    ])
        .map((f: any) => ({
          month: f.month,
          year: f.year,
          monthName: (moment.localeData() as any)._monthsShort[f.month - 1],
          editable: f.editable
        }))
        .uniqBy((f: any) => `${f.year}${f.month}`)
        .orderBy((f: any) => f.month)
        .orderBy((f: any) => f.year)
        .value();
  }

  public get models() {
    if (!_.size(this.state.data)) {
      return [];
    }

    return _([
      //   ...this.state.data.forecast_RapFamilyResultsPerMonth.map((d: any) => {
      //     //d.editable = !(d.yearReference <= this.state.currentYear && d.monthReference <= this.state.currentMonth);
      //     d.trend = 0; //d.value;
      //     return d;
      //   }),
      ...this.state.data.consolidate_RapFamilyResultsPerMonth.map((d: any) => {
        //d.editable = !(d.yearReference <= this.state.currentYear && d.monthReference <= this.state.currentMonth);
        d.accomplished = d.value;
        return d;
      }),
      ...this.state.data.forecast_RapFamilyResultsPerMonth.map((d: any) => {
        //d.editable = !(d.yearReference <= this.state.currentYear && d.monthReference <= this.state.currentMonth);
        d.meta = d.value;
        return d;
      })
    ])
        .orderBy((family: any) => family.familyName)
        .groupBy((family: any) => family.familyName)
        .map((family: any[], name: string) => ({
          name,
          values: this.createMonthlyValues(SalesChannel.All, family)
        }))
        .value();
  }

  public get directSalesPerformanceChart() {
    const forecast = {
      meta: _(this.models)
          .map((model: any) => model.values)
          .flatten()
          .sumBy('meta'),
      accomplished: _(this.models)
          .map((model: any) => model.values)
          .flatten()
          .sumBy('accomplished'),
      total: _(this.models)
          .map((model: any) => model.values)
          .flatten()
          .sumBy((model: any) => model.meta + model.accomplished),
      category: this.showDateTotal() ? this.dateInitialAndFinalProject : '--'
    };

    return [forecast];
  }

  public get directSalesByProductChart() {
    return _(this.models)
        .map((model: any) => ({
          name: model.name,
          meta: this.getTotal(model.values, 'meta'),
          accomplished: this.getTotal(model.values, 'accomplished')
        }))
        .value();
  }

  public get directSalesByChannelChart() {
    return _(this.models)
        .map((model: any) => Object.values(model.channels))
        .flattenDeep()
        .orderBy((channel: any) => channel.idSaleChannel)
        .groupBy((channel: any) => channel.channelName)
        .map((channel: any[], name: string) => ({
          name,
          meta: this.getTotal(channel, 'meta'),
          accomplished: this.getTotal(channel, 'accomplished')
        }))
        .value();
  }

  public verifyModel(model: any, index: number) {
    const expectedValue = this.models
        .filter((val: any) => val.name === model.name)
        .reduce((acc: any, val: any) => (acc += +val.values[index].value), 0);

    const actualValue = Object.values(model.channels).reduce((acc, val: any) => (acc += val[index].value), 0);

    return expectedValue !== actualValue;
  }

  public getTotal(data: any[], property: string, filterDate?: boolean) {
    if (filterDate) {
      return data
          .filter((val: any) => !val.editable)
          .reduce((acc: number, val: any) => (acc += +val[property] || 0), 0);
    }
    return data.reduce((acc: number, val: any) => (acc += +val[property] || 0), 0);
  }

  public getTotalWithValues(data: any[], property: string, filterDate?: boolean) {
    return data.reduce((acc: number, val: any) => (acc += this.getTotal(val.values, property, filterDate)), 0);
  }

  private createMonthlyValues(channelId: number, family: any[]) {
    return _.reduce(
        this.periods,
        (acc: any[], period: any) => {
          const entries: any[] = _.filter(family, (f: any) => f.month === period.month && f.year === period.year);

          acc.push({
            ...period,
            ...entries[0],
            accomplished: _.sumBy(entries, (e: any) => +e.accomplished || 0),
            trend: _.sumBy(entries, (e: any) => +e.trend || 0),
            channelName: 'Total',
            idSaleChannel: 0,
            meta: _.sumBy(entries, (e: any) => +e.meta || 0),
            monthName: (moment.localeData() as any)._monthsShort[period.month - 1],
            updatedAt: null
          });

          return acc;
        },
        []
    );
  }

  public get dateInitialAndFinalProjectConsolidado() {
    if (this.dateFilterConsolidate && this.dateFilterConsolidate.length <= 0) {
      return '';
    }
    return _.map(this.dateFilterConsolidate, (m: any) => m.year)[0] ===
    _.map(this.dateFilterConsolidate, (m: any) => m.year)[this.dateFilterConsolidate.length - 1]
        ? _.map(this.dateFilterConsolidate, (m: any) => m.year)[0]
        : moment()
            .year(_.map(this.dateFilterConsolidate, (m: any) => m.year)[0])
            .date(-1)
            .format('YYYY') +
        ' a ' +
        moment()
            .year(_.map(this.dateFilterConsolidate, (m: any) => m.year)[this.dateFilterConsolidate.length - 1])
            .date(-1)
            .format('YYYY');
  }

  public get dateInitialAndFinalProject() {
    return _.map(this.dateFilterConsolidate, (m: any) => m.year)[0] ===
    _.map(this.dateFilterConsolidate, (m: any) => m.year)[this.dateFilterConsolidate.length - 1]
        ? _.map(this.dateFilterConsolidate, (m: any) => m.year)[0]
        : moment()
            .year(_.map(this.dateFilterConsolidate, (m: any) => m.year)[0])
            .date(-1)
            .format('YYYY') +
        ' a ' +
        moment()
            .year(_.map(this.dateFilterConsolidate, (m: any) => m.year)[this.dateFilterConsolidate.length - 1])
            .date(-1)
            .format('YYYY');
  }

  public showDateTotal() {
    return _.some(
        this.models,
        (s: any) => this.getTotal(s.values, 'meta') > 0 || this.getTotal(s.values, 'accomplished') > 0
    );
  }

  public showDatePartial() {
    return this.dateFilterConsolidate.length > 0;
  }

  public get dateFilterConsolidate() {
    return _(this.models)
        .map((model: any) => model.values)
        .flattenDeep()
        .map((m: any) => ({month: m.month, year: m.year}))
        .uniqBy((f: any) => f.month + f.year)
        .orderBy((f: any) => f.year)
        .orderBy((f: any) => f.month)
        .value();
  }

  @Watch('dataQuery')
  public requestData() {
    const req = [
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/approval/family/channels`),
      httpService.http.get(
          `${CONFIG.URL.NEODASH_API}/api/dap/approval/${
              this.dataQuery.relatorio.value
          }/rap/GetBudgetVsDoneFlowResults/${this.dataQuery.dealer.value}`
      ),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.dataQuery.relatorio.value}`)
    ];

    Promise.all(req)
        .then((res: any) => {
          this.state.channels = res[0].data;
          this.state.data = res[1].data;
          this.state.project = res[2].data;
        })
        .catch((err: AxiosError) => console.log(err.message));
  }

  public created() {
    this.requestData();
  }
}
